import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const PartnersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGetInTouch = () => {
    navigate('/contacts');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section
        className="relative h-[400px] flex items-center justify-center bg-cover bg-center mt-20"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/6dd4a178e4c09855763c3fa9fb1e08fe.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl font-bold mb-4">{t('partners.hero.title')}</h1>
          <p className="text-xl max-w-2xl mx-auto">{t('partners.hero.subtitle')}</p>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              {t('partners.ourPartners')}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {t('partners.description')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* HPE */}
            <a 
              href="https://www.hpe.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/4/46/Hewlett_Packard_Enterprise_logo.svg" 
                alt="Hewlett-Packard Enterprise" 
                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* HP Inc */}
            <a 
              href="https://www.hp.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/a/ad/HP_logo_2012.svg" 
                alt="HP Inc." 
                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Dell */}
            <a 
              href="https://www.dell.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/1/18/Dell_logo_2016.svg" 
                alt="Dell" 
                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Lenovo */}
            <a 
              href="https://www.lenovo.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/b/b8/Lenovo_logo_2015.svg" 
                alt="Lenovo" 
                className="w-[70%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Asus */}
            <a 
              href="https://www.asus.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/2/2e/ASUS_Logo.svg" 
                alt="Asus" 
                className="w-[70%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Acer */}
            <a 
              href="https://www.acer.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/0/00/Acer_2011.svg" 
                alt="Acer" 
                className="w-[70%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Aruba */}
            <a 
              href="https://www.arubanetworks.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/7cc1dd5c1a0257b7c4fb24ac6fafa655.jpeg" 
                alt="Aruba" 
                className="w-[55%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* NEC */}
            <a 
              href="https://www.nec.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/2d2055b08edc1dc7b73b010d0425de33.jpeg" 
                alt="NEC" 
                className="w-[50%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Panasonic */}
            <a 
              href="https://www.panasonic.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/9bfb426de215e5bff2beae9ca34f4095.png" 
                alt="Panasonic" 
                className="w-[60%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* LG */}
            <a 
              href="https://www.lg.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/34cd4df44573da9723fa70f6d2d12c2a.png" 
                alt="LG" 
                className="w-[60%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Samsung */}
            <a 
              href="https://www.samsung.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/3329c60384c97ffe305279d5a36663a3.png" 
                alt="Samsung" 
                className="w-[85%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Televic Conference */}
            <a 
              href="https://www.televic-conference.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/d963aa7dfb14777017db4470d119a31c.png" 
                alt="Televic Conference" 
                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Poly */}
            <a 
              href="https://www.poly.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/693e04377a7f0d5742bb7fa77104137e.png" 
                alt="Poly" 
                className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* Sennheiser */}
            <a 
              href="https://www.sennheiser.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/27ea06c235d9ea91bd175630ec023a56.png" 
                alt="Sennheiser" 
                className="w-[85%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* APC */}
            <a 
              href="https://www.apc.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/76f52bf3bd589da89df0a51ec10ae312.png" 
                alt="APC" 
                className="w-[85%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>

            {/* TrippLite */}
            <a 
              href="https://www.tripplite.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border border-gray-200 rounded-lg p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer h-32"
            >
              <img 
                src="https://static.readdy.ai/image/91fb7576e322234c878e1d6a6d2cf40a/06d8e93189fbe5219ec951af064395ac.png" 
                alt="TrippLite" 
                className="w-[85%] h-auto object-contain transition-transform duration-300 group-hover:scale-110"
              />
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-900">{t('partners.cta.title')}</h2>
          <p className="text-xl mb-8 text-gray-600">{t('partners.cta.description')}</p>
          <button 
            onClick={handleGetInTouch}
            className="bg-[#1E3A8A] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#1E3A8A]/90 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('partners.cta.button')}
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PartnersPage;
